import { fetcher } from '@commenda/utils';

export interface AdminSetComplianceTypeVisibilityBulkArgs {
  // filingCompositeIds = ObligationRules.compositeId = ComplianceItem.type
  filingCompositeIds: string[];
  hidden: boolean;
}

/** Sets the same show/hide state on many compliance types at once. Admin-only (guarded server-side). Throws on failure. */
export async function setAdminComplianceTypeVisibilityBulk(args: AdminSetComplianceTypeVisibilityBulkArgs): Promise<void> {
  const response = await fetcher('compliance-type-visibility/bulk', {
    method: 'POST',
    body: args,
  });

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as { message?: unknown } | null;
    const message = typeof body?.message === 'string' ? body.message : 'Failed to update compliance type visibility';
    throw new Error(message);
  }
}
